import styled, { css } from 'styled-components'
import {
    svgStroke,
    belowContainer
} from 'utilities/styled'
import { containerProps, CardList } from '../s'
import Link from 'components/link'
import SymbolBase from 'components/symbol'
import { ancestorHover } from 'components/symbol/s'
import { ArrowRight } from 'styled-icons/feather'

export const CardListRow = styled(CardList.Row)`
    ${belowContainer(containerProps)`
        display: grid;
        grid-template-columns: subgrid;
        grid-column: 1 / -1;
    `}
`

export const SurveyLink = styled(Link)`
    display: grid;
    grid-template-columns: subgrid;
    grid-column: 1 / -1;

    &:where(:hover, :focus) {
        text-decoration: none;

        .name {
            text-decoration: underline;
        }
    }
`

export const CardListCell = styled(CardList.Cell)`
    ${({ $cell }) => $cell === 'meta' && css`
        flex-direction: column;
        align-items: start;
    `}
`

export const Symbol = styled(SymbolBase)`
    ${ancestorHover(SurveyLink)}
`

export const Navigate = styled(ArrowRight)`
    ${svgStroke()}

    transition: transform .1s ease-in-out;

    ${SurveyLink}:where(:hover, :focus) & {
        transform: translateX(4px);
    }
`